const defaultSettings = {
  acceptRequired: false,
  isAcceptedByDefault: false
};
export const getTermsAndConditionsSettings = clientData => {
  if (!(clientData != null && clientData.termsAndConditionsSettings)) {
    return defaultSettings;
  }
  try {
    const {
      acceptRequired,
      isAcceptedByDefault
    } = JSON.parse(clientData.termsAndConditionsSettings);
    return {
      acceptRequired: acceptRequired ?? defaultSettings.acceptRequired,
      isAcceptedByDefault: isAcceptedByDefault ?? defaultSettings.isAcceptedByDefault
    };
  } catch {
    return defaultSettings;
  }
};
//# sourceMappingURL=get-terms-and-conditions-settings.js.map